"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNumber = toNumber;
/*! Copyright (c) 2019, XAPPmedia */
/**
 * Converts the string to a number, if applicable.
 * @param number
 */
function toNumber(stringOrNumber) {
    if (typeof stringOrNumber === "number") {
        return stringOrNumber;
    }
    const possible = Number(stringOrNumber);
    if (isNaN(possible)) {
        return undefined;
    }
    else {
        return possible;
    }
}
//# sourceMappingURL=toNumber.js.map